import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { SharedModule } from "../../../shared/shared.module";
import { ContractsComponent } from "./contract.component";
import { CreateContractComponent } from "./create-contract/create-contract.component";
import { ManageContractComponent } from "./manage-contract/manage-contract.component";
import { RenewContractComponent } from "./renew-contract/renew-contract.component";

@NgModule({
  declarations: [ContractsComponent, CreateContractComponent, ManageContractComponent, RenewContractComponent],
  imports: [CoreModule, SharedModule],
  exports: [ContractsComponent, CreateContractComponent, ManageContractComponent, RenewContractComponent],
})
export class ContractModule {}
